import React, { useEffect } from 'react';
import { useValidateInvitation } from '../../api/Invitations';
import useAuth from '../../auth/useAuth';
import Loading from '../../components/Loading';
import useParams from '../../hooks/useParams';
import InvalidInvitation from './InvalidInvitation';

function ValidateInvitation() {
  const { token } = useParams();
  const { loginWithRedirect } = useAuth();

  const { mutate: validateInvitation, isError: invitationError } = useValidateInvitation();

  useEffect(() => {
    validateInvitation(
      { token },
      // QuestionPro owns account creation, so there is no signup hint to pass
      // through - an invited user signs in and is provisioned on first call.
      { onSuccess: () => loginWithRedirect() },
    );
  }, [validateInvitation, token, loginWithRedirect]);

  return invitationError ? <InvalidInvitation /> : <Loading />;
}

export default ValidateInvitation;
